module.exports = __webpack_public_path__ + "static/media/banner_dark_mybarrister.ec9f248b.png";